var noop=function noop(){};var noopReturn=function noopReturn(v){return v;};export{noop,noopReturn};